module.exports = __webpack_public_path__ + "img/05_tu.dd763520.png";